"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientCommunication = void 0;
/**
 * Demographics and other administrative information about an individual or animal receiving care or other health-related services.
 */
var PatientCommunication = /** @class */ (function () {
    function PatientCommunication() {
    }
    return PatientCommunication;
}());
exports.PatientCommunication = PatientCommunication;
